import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

export const MamarottePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'color-mix(in srgb, var(--color-accent)  8%, var(--color-surface))',
      100: 'color-mix(in srgb, var(--color-accent) 16%, var(--color-surface))',
      200: 'color-mix(in srgb, var(--color-accent) 28%, var(--color-surface))',
      300: 'color-mix(in srgb, var(--color-accent) 45%, var(--color-surface))',
      400: 'color-mix(in srgb, var(--color-accent) 70%, var(--color-surface))',
      500: 'var(--color-accent)',
      600: 'var(--color-accent-hover)',
      700: 'var(--color-accent-active)',
      800: 'color-mix(in srgb, var(--color-accent-active) 75%, var(--color-ink))',
      900: 'color-mix(in srgb, var(--color-accent-active) 55%, var(--color-ink))',
      950: 'color-mix(in srgb, var(--color-accent-active) 35%, var(--color-ink))',
    },

    colorScheme: {
      light: {
        surface: {
          0: 'var(--color-surface)',
          50: 'var(--color-surface-2)',
          100: 'var(--color-paper)',
          200: 'var(--color-paper-2)',
          300: 'var(--color-paper-3)',
          400: 'var(--color-ink-4)',
          500: 'var(--color-ink-3)',
          600: 'var(--color-ink-2)',
          700: 'color-mix(in srgb, var(--color-ink) 60%, var(--color-ink-2))',
          800: 'var(--color-ink)',
          900: 'color-mix(in srgb, var(--color-ink) 80%, black)',
          950: 'color-mix(in srgb, var(--color-ink) 60%, black)',
        },
        formField: {
          background: 'var(--color-surface)',
          disabledBackground: 'var(--color-paper-2)',
          filledBackground: 'var(--color-paper)',
          filledHoverBackground: 'var(--color-paper-2)',
          filledFocusBackground: 'var(--color-paper)',
          borderColor: 'var(--color-rule)',
          hoverBorderColor: 'var(--color-rule-2)',
          focusBorderColor: 'var(--color-accent)',
          invalidBorderColor: 'var(--color-danger-fg)',
          color: 'var(--color-ink)',
          disabledColor: 'var(--color-ink-4)',
          placeholderColor: 'var(--color-ink-4)',
          invalidPlaceholderColor: 'var(--color-danger-fg)',
          floatLabelColor: 'var(--color-ink-3)',
          floatLabelFocusColor: 'var(--color-accent)',
          floatLabelActiveColor: 'var(--color-ink-3)',
          iconColor: 'var(--color-ink-3)',
        },
        text: {
          color: 'var(--color-ink)',
          hoverColor: 'var(--color-ink)',
          mutedColor: 'var(--color-ink-3)',
          hoverMutedColor: 'var(--color-ink-2)',
        },
        content: {
          background: 'var(--color-surface)',
          hoverBackground: 'var(--color-paper-2)',
          borderColor: 'var(--color-rule)',
          color: 'var(--color-ink)',
          hoverColor: 'var(--color-ink)',
        },
        highlight: {
          background: 'color-mix(in srgb, var(--color-accent) 15%, transparent)',
          focusBackground: 'color-mix(in srgb, var(--color-accent) 25%, transparent)',
          color: 'var(--color-accent)',
          focusColor: 'var(--color-accent)',
        },
        overlay: {
          select: {
            background: 'var(--color-paper-2)',
            borderColor: 'var(--color-rule)',
            color: 'var(--color-ink)',
          },
          popover: {
            background: 'var(--color-paper-2)',
            borderColor: 'var(--color-rule)',
            color: 'var(--color-ink)',
          },
          modal: {
            background: 'var(--color-paper)',
            borderColor: 'var(--color-rule)',
            color: 'var(--color-ink)',
          },
        },
        list: {
          option: {
            focusBackground: 'var(--color-surface-2)',
            selectedBackground: 'color-mix(in srgb, var(--color-accent) 12%, var(--color-paper))',
            selectedFocusBackground: 'color-mix(in srgb, var(--color-accent) 22%, var(--color-paper))',
            color: 'var(--color-ink)',
            focusColor: 'var(--color-ink)',
            selectedColor: 'var(--color-accent)',
            selectedFocusColor: 'var(--color-accent)',
            icon: {
              color: 'var(--color-ink-4)',
              focusColor: 'var(--color-ink-3)',
            },
            group: {
              color: 'var(--color-ink-3)',
            },
          },
        },
        navigation: {
          item: {
            focusBackground: 'var(--color-surface-2)',
            activeBackground: 'var(--color-paper-2)',
            color: 'var(--color-ink)',
            focusColor: 'var(--color-ink)',
            activeColor: 'var(--color-ink)',
          },
        },
        mask: {
          background: 'var(--color-mask)',
        },
      },

      dark: {
        surface: {
          0: 'var(--color-surface)',
          50: 'var(--color-surface-2)',
          100: 'var(--color-paper)',
          200: 'var(--color-paper-2)',
          300: 'var(--color-paper-3)',
          400: 'var(--color-ink-4)',
          500: 'var(--color-ink-3)',
          600: 'var(--color-ink-2)',
          700: 'color-mix(in srgb, var(--color-ink) 60%, var(--color-ink-2))',
          800: 'var(--color-ink)',
          900: 'color-mix(in srgb, var(--color-ink) 80%, white)',
          950: 'color-mix(in srgb, var(--color-ink) 60%, white)',
        },
        formField: {
          background: 'var(--color-surface)',
          disabledBackground: 'var(--color-paper-2)',
          borderColor: 'var(--color-rule)',
          hoverBorderColor: 'var(--color-rule-2)',
          focusBorderColor: 'var(--color-accent)',
          invalidBorderColor: 'var(--color-danger-fg)',
          color: 'var(--color-ink)',
          disabledColor: 'var(--color-ink-4)',
          placeholderColor: 'var(--color-ink-4)',
          iconColor: 'var(--color-ink-3)',
        },
        text: {
          color: 'var(--color-ink)',
          mutedColor: 'var(--color-ink-3)',
        },
        content: {
          background: 'var(--color-surface)',
          borderColor: 'var(--color-rule)',
          color: 'var(--color-ink)',
        },
        overlay: {
          select: {
            background: 'var(--color-paper-2)',
            borderColor: 'var(--color-rule)',
            color: 'var(--color-ink)',
          },
          popover: {
            background: 'var(--color-paper-2)',
            borderColor: 'var(--color-rule)',
            color: 'var(--color-ink)',
          },
          modal: {
            background: 'var(--color-paper)',
            borderColor: 'var(--color-rule)',
            color: 'var(--color-ink)',
          },
        },
      },
    },

    focusRing: {
      width: '2px',
      style: 'solid',
      color: 'var(--color-accent)',
      offset: '2px',
      shadow: 'none',
    },

    transitionDuration: '0.15s',
  },

  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              background: 'var(--color-accent)',
              hoverBackground: 'var(--color-accent-hover)',
              activeBackground: 'var(--color-accent-active)',
              borderColor: 'var(--color-accent)',
              hoverBorderColor: 'var(--color-accent-hover)',
              activeBorderColor: 'var(--color-accent-active)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-accent)', shadow: 'none' },
            },
            secondary: {
              background: 'var(--color-surface)',
              hoverBackground: 'var(--color-paper-3)',
              activeBackground: 'var(--color-rule-2)',
              borderColor: 'var(--color-rule-2)',
              hoverBorderColor: 'var(--color-rule-2)',
              activeBorderColor: 'var(--color-rule)',
              color: 'var(--color-ink)',
              hoverColor: 'var(--color-ink)',
              activeColor: 'var(--color-ink)',
              focusRing: { color: 'var(--color-ink-2)', shadow: 'none' },
            },
            success: {
              background: 'var(--color-success-fg)',
              hoverBackground: 'color-mix(in srgb, var(--color-success-fg) 85%, black)',
              activeBackground: 'color-mix(in srgb, var(--color-success-fg) 70%, black)',
              borderColor: 'var(--color-success-fg)',
              hoverBorderColor: 'color-mix(in srgb, var(--color-success-fg) 85%, black)',
              activeBorderColor: 'color-mix(in srgb, var(--color-success-fg) 70%, black)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-success-fg)', shadow: 'none' },
            },
            info: {
              background: 'var(--color-info-fg)',
              hoverBackground: 'color-mix(in srgb, var(--color-info-fg) 85%, black)',
              activeBackground: 'color-mix(in srgb, var(--color-info-fg) 70%, black)',
              borderColor: 'var(--color-info-fg)',
              hoverBorderColor: 'color-mix(in srgb, var(--color-info-fg) 85%, black)',
              activeBorderColor: 'color-mix(in srgb, var(--color-info-fg) 70%, black)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-info-fg)', shadow: 'none' },
            },
            warn: {
              background: 'var(--color-warning-fg)',
              hoverBackground: 'color-mix(in srgb, var(--color-warning-fg) 85%, black)',
              activeBackground: 'color-mix(in srgb, var(--color-warning-fg) 70%, black)',
              borderColor: 'var(--color-warning-fg)',
              hoverBorderColor: 'color-mix(in srgb, var(--color-warning-fg) 85%, black)',
              activeBorderColor: 'color-mix(in srgb, var(--color-warning-fg) 70%, black)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-warning-fg)', shadow: 'none' },
            },
            danger: {
              background: 'var(--color-danger-fg)',
              hoverBackground: 'color-mix(in srgb, var(--color-danger-fg) 85%, black)',
              activeBackground: 'color-mix(in srgb, var(--color-danger-fg) 70%, black)',
              borderColor: 'var(--color-danger-fg)',
              hoverBorderColor: 'color-mix(in srgb, var(--color-danger-fg) 85%, black)',
              activeBorderColor: 'color-mix(in srgb, var(--color-danger-fg) 70%, black)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-danger-fg)', shadow: 'none' },
            },
          },
        },
        dark: {
          root: {
            primary: {
              background: 'var(--color-accent)',
              hoverBackground: 'var(--color-accent-hover)',
              activeBackground: 'var(--color-accent-active)',
              borderColor: 'var(--color-accent)',
              hoverBorderColor: 'var(--color-accent-hover)',
              activeBorderColor: 'var(--color-accent-active)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-accent)', shadow: 'none' },
            },
            secondary: {
              background: 'var(--color-surface)',
              hoverBackground: 'var(--color-paper-3)',
              activeBackground: 'var(--color-rule-2)',
              borderColor: 'var(--color-rule-2)',
              hoverBorderColor: 'var(--color-rule-2)',
              activeBorderColor: 'var(--color-rule)',
              color: 'var(--color-ink)',
              hoverColor: 'var(--color-ink)',
              activeColor: 'var(--color-ink)',
              focusRing: { color: 'var(--color-ink-2)', shadow: 'none' },
            },
            success: {
              background: 'var(--color-success-fg)',
              hoverBackground: 'color-mix(in srgb, var(--color-success-fg) 85%, black)',
              activeBackground: 'color-mix(in srgb, var(--color-success-fg) 70%, black)',
              borderColor: 'var(--color-success-fg)',
              hoverBorderColor: 'color-mix(in srgb, var(--color-success-fg) 85%, black)',
              activeBorderColor: 'color-mix(in srgb, var(--color-success-fg) 70%, black)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-success-fg)', shadow: 'none' },
            },
            info: {
              background: 'var(--color-info-fg)',
              hoverBackground: 'color-mix(in srgb, var(--color-info-fg) 85%, black)',
              activeBackground: 'color-mix(in srgb, var(--color-info-fg) 70%, black)',
              borderColor: 'var(--color-info-fg)',
              hoverBorderColor: 'color-mix(in srgb, var(--color-info-fg) 85%, black)',
              activeBorderColor: 'color-mix(in srgb, var(--color-info-fg) 70%, black)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-info-fg)', shadow: 'none' },
            },
            warn: {
              background: 'var(--color-warning-fg)',
              hoverBackground: 'color-mix(in srgb, var(--color-warning-fg) 85%, black)',
              activeBackground: 'color-mix(in srgb, var(--color-warning-fg) 70%, black)',
              borderColor: 'var(--color-warning-fg)',
              hoverBorderColor: 'color-mix(in srgb, var(--color-warning-fg) 85%, black)',
              activeBorderColor: 'color-mix(in srgb, var(--color-warning-fg) 70%, black)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-warning-fg)', shadow: 'none' },
            },
            danger: {
              background: 'var(--color-danger-fg)',
              hoverBackground: 'color-mix(in srgb, var(--color-danger-fg) 85%, black)',
              activeBackground: 'color-mix(in srgb, var(--color-danger-fg) 70%, black)',
              borderColor: 'var(--color-danger-fg)',
              hoverBorderColor: 'color-mix(in srgb, var(--color-danger-fg) 85%, black)',
              activeBorderColor: 'color-mix(in srgb, var(--color-danger-fg) 70%, black)',
              color: 'var(--color-accent-fg)',
              hoverColor: 'var(--color-accent-fg)',
              activeColor: 'var(--color-accent-fg)',
              focusRing: { color: 'var(--color-danger-fg)', shadow: 'none' },
            },
          },
        },
      },
    },

    tabs: {
      tablist: {
        background: 'var(--color-ink)',
        borderColor: 'var(--color-rule)',
      },
      tab: {
        background: 'transparent',
        hoverBackground: 'transparent',
        activeBackground: 'transparent',
        borderColor: 'var(--color-rule)',
        hoverBorderColor: 'var(--color-rule)',
        activeBorderColor: 'var(--color-accent)',
        color: 'color-mix(in srgb, var(--color-paper) 70%, var(--color-ink-3))',
        hoverColor: 'var(--color-paper)',
        activeColor: 'var(--color-paper)',
        fontWeight: '600',
      },
      tabpanel: {
        background: 'transparent',
        color: 'var(--color-ink)',
        padding: '0',
      },
      activeBar: {
        background: 'var(--color-accent)',
      },
    },

    dialog: {
      root: {
        background: 'var(--color-paper)',
        borderColor: 'var(--color-rule)',
        color: 'var(--color-ink)',
        shadow: 'var(--shadow-xl)',
      },
      header: { padding: 'var(--space-6)' },
      content: { padding: 'var(--space-6)' },
      footer: { padding: 'var(--space-4) var(--space-6)' },
    },

    popover: {
      root: {
        background: 'var(--color-paper-2)',
        borderColor: 'var(--color-rule)',
        color: 'var(--color-ink)',
        shadow: 'var(--shadow-lg)',
      },
      content: { padding: 'var(--space-2)' },
    },

    toggleswitch: {
      root: {
        background: 'var(--color-rule)',
        hoverBackground: 'var(--color-rule-2)',
        checkedBackground: 'var(--color-accent)',
        checkedHoverBackground: 'var(--color-accent-hover)',
        disabledBackground: 'var(--color-paper-3)',
      },
      handle: {
        background: 'var(--color-surface)',
        hoverBackground: 'var(--color-surface)',
        checkedBackground: 'var(--color-accent-fg)',
      },
    },

    badge: {
      primary: { background: 'var(--color-accent)', color: 'var(--color-accent-fg)' },
      secondary: { background: 'var(--color-paper-2)', color: 'var(--color-ink-2)' },
      success: { background: 'var(--color-success-bg)', color: 'var(--color-success-fg)' },
      info: { background: 'var(--color-info-bg)', color: 'var(--color-info-fg)' },
      warn: { background: 'var(--color-warning-bg)', color: 'var(--color-warning-fg)' },
      danger: { background: 'var(--color-danger-bg)', color: 'var(--color-danger-fg)' },
      contrast: { background: 'var(--color-ink)', color: 'var(--color-surface)' },
    },

    tag: {
      primary: {
        background: 'color-mix(in srgb, var(--color-accent) 15%, var(--color-paper))',
        color: 'var(--color-accent)',
      },
      secondary: { background: 'var(--color-paper-2)', color: 'var(--color-ink-2)' },
      success: { background: 'var(--color-success-bg)', color: 'var(--color-success-fg)' },
      info: { background: 'var(--color-info-bg)', color: 'var(--color-info-fg)' },
      warn: { background: 'var(--color-warning-bg)', color: 'var(--color-warning-fg)' },
      danger: { background: 'var(--color-danger-bg)', color: 'var(--color-danger-fg)' },
      contrast: { background: 'var(--color-ink)', color: 'var(--color-surface)' },
    },

    chip: {
      root: {
        background: 'var(--color-paper-2)',
        color: 'var(--color-ink)',
      },
      icon: {
        color: 'var(--color-ink-2)',
      },
      removeIcon: {
        color: 'var(--color-ink-3)',
      },
    },

    // L'animation d'Aura passe par quatre couleurs (rouge, bleu, vert, jaune) et écrase un `stroke` posé en CSS
    progressspinner: {
      colorScheme: {
        light: {
          root: {
            colorOne: 'var(--color-accent)',
            colorTwo: 'var(--color-accent)',
            colorThree: 'var(--color-accent)',
            colorFour: 'var(--color-accent)',
          },
        },
        dark: {
          root: {
            colorOne: 'var(--color-accent)',
            colorTwo: 'var(--color-accent)',
            colorThree: 'var(--color-accent)',
            colorFour: 'var(--color-accent)',
          },
        },
      },
    },
  },
})
